"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("./index");
var usersCompany_1 = require("./usersCompany");
var User = /** @class */ (function (_super) {
    __extends(User, _super);
    function User() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    User.prototype.getCompanies = function (confirmedOnly) {
        if (confirmedOnly === void 0) { confirmedOnly = true; }
        return this.getUsersCompanies()
            .filter(function (uc) {
            return confirmedOnly
                ? uc.attributes.confirmed && !uc.attributes.deleted
                : !uc.attributes.deleted;
        })
            .map(function (uc) { return uc.getCompany(); });
    };
    User.prototype.getUsersCompanies = function () {
        return index_1.getMany(this.originalResponse, 'usersCompanies', usersCompany_1.UsersCompany);
    };
    return User;
}(index_1.BaseModel));
exports.User = User;
